import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { camps } from '../../../models/models.generated';

@Injectable()
export class PurchaseEditEventService {

    public cartChanged: EventEmitter<camps.OfficeCartInfo> = new EventEmitter<camps.OfficeCartInfo>();

    constructor() { }

    public onCartChanged(cart: camps.OfficeCartInfo){
        this.cartChanged.emit(cart);
    }
}
